import { useEffect } from 'react';

import { MachineContext, useMachineContext } from 'hooks/useMachineContext';
import { useUserContext } from 'hooks/useUserContext';

export enum ClaimType {
  CHIME_ENROLLMENT = 'chime_enrollment',
  DEBIT_CARD = 'debit_card',
}

type useLandingPageApi = {
  onCtaClickDebit: () => void;
  onCtaClickChime: () => void;
};

function useCreateLandingPageHook(
  fireCtaTappedEvents: (claimType: ClaimType) => void,
  fireLandingPageViewedEvents: () => void
): useLandingPageApi {
  const [, send] = useMachineContext(MachineContext);
  const [userData] = useUserContext();
  const { publicId } = userData;

  useEffect(() => {
    fireLandingPageViewedEvents();
  }, [publicId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fireDefaultCtaButtonEvents = (claimType: ClaimType) => {
    fireCtaTappedEvents(claimType);
  };

  const onCtaClickChime = () => {
    fireDefaultCtaButtonEvents(ClaimType.CHIME_ENROLLMENT);
  };

  const onCtaClickDebit = () => {
    fireDefaultCtaButtonEvents(ClaimType.DEBIT_CARD);
    send('NEXT');
  };

  return {
    onCtaClickDebit,
    onCtaClickChime,
  };
}

export default useCreateLandingPageHook;
